import React from "react";
import cx from "classnames";
import { Trans, t } from "@lingui/macro";

import { USD_DECIMALS } from "lib/legacy";
import { formatAmount } from "lib/numbers";
import { DARK_THEME, GRAY_THEME } from "./constants";
import ExchangeTable from "./table/ExchangeTable";
import ExchangeRow from "./table/ExchangeRow";
import ExchangeTokenInfo from "./table/ExchangeTokenInfo";
import EmptyRow from "./table/EmptyRow";

export default function ClosedPositionsList(props) {
  const { infoTokens, theme, connectWallet, positions, className } = props;

  const renderHead = () => {
    return (
      <tr className="Exchange-list-header">
        <th className="Start">
          <Trans>Position</Trans>
        </th>

        <th>
          <Trans>Side</Trans>
        </th>
        <th>
          <Trans>Size</Trans>
        </th>
        <th>
          <Trans>Closing Price</Trans>
        </th>
        <th>
          <Trans>Entry Price</Trans>
        </th>
        <th className="End">
          <Trans>PnL</Trans>
        </th>
      </tr>
    );
  };

  return (
    <div
      className={cx(className || "ClosedPositionsList", {
        gray: theme === GRAY_THEME,
        dark: theme === DARK_THEME,
      })}
    >
      <ExchangeTable>
        {renderHead()}
        <EmptyRow connectWallet={connectWallet} msg="You have no closed positions." items={positions} />
        {positions.map((item) => (
          <ExchangeRow key={`${item.isLong}-${item.id}`}>
            <td className="Exchange-list-item-type" key={item.id}>
              <ExchangeTokenInfo infoTokens={infoTokens} token={item.token} leverage={item.leverage} />
            </td>
            <td>
              <div>
                <span className={cx({ long: item.isLong, short: !item.isLong })}>
                  {item.isLong ? t`Long` : t`Short`}
                </span>
              </div>
            </td>
            <td className="Exchange-list-item-type">${formatAmount(item.size, USD_DECIMALS, 4, true)}</td>
            <td>${formatAmount(item.exitPrice, USD_DECIMALS, 2, true)}</td>
            <td>${formatAmount(item.entryPrice, USD_DECIMALS, 2, true)}</td>
            <td>
              <span className={item.realisedPnl.gt(0) ? "positive" : "negative"}>
                ${formatAmount(item.realisedPnl, USD_DECIMALS, 2, true)}
              </span>
            </td>
          </ExchangeRow>
        ))}
      </ExchangeTable>
    </div>
  );
}
